import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { useFieldMetadata } from '../../contexts/FieldMetadataContext';

const HeaderFieldComponent = ({ fieldId }) => {
    const { fieldsMetadata } = useFieldMetadata();

//    console.log('[HeaderFieldComponent] Entire fieldsMetadata:', fieldsMetadata);

    const fieldMetadata = fieldsMetadata[fieldId];
//    console.log('[HeaderFieldComponent] Retrieved metadata for field ID:', fieldId, fieldMetadata);

    if (!fieldMetadata) {
        console.error(`[HeaderFieldComponent] Metadata not found for field ID: ${fieldId}`);
        return null;
    }

    const {
        header = 'Default Header',
        enableSubheader = false,
        subheader = '',
        headerStyle = {}, 
        subheaderStyle = {}, 
    } = fieldMetadata;

    // Improved inline textAlign parsing (handles missing semicolon, extra spaces, etc.)
    const inlineTextAlignMatch = header.match(/text-align:\s*([\w-]+)/i);
    const inlineTextAlign = inlineTextAlignMatch ? inlineTextAlignMatch[1] : null;

    // Final textAlign logic
    const headerAlignment = inlineTextAlign || headerStyle.textAlign || 'center';
    const subheaderAlignment = subheaderStyle.textAlign || headerAlignment; // Align subheader to match header by default

//    console.log(`[HeaderFieldComponent] Rendering fieldId: ${fieldId} with alignment: ${headerAlignment}`);

    return (
        <Box
            sx={{
                display: 'block',      // ✅ Ensures full-width alignment
                width: '100%',         // ✅ Ensures text alignment applies across full width
                textAlign: headerAlignment,  // ✅ Applied only once here
                margin: headerStyle.margin || '0px 0',
                padding: headerStyle.padding || '0px 0',
                    gap: '0px'  // ✅ Default spacing, which users can modify

            }}
        >
            {/* Render Header */}
            <Typography
                component="h1"
                gutterBottom
                sx={{
                    fontSize: headerStyle.fontSize || '24px',
                    color: headerStyle.headerColor || '#000000',
                    fontWeight: headerStyle.fontWeight || 'bold',
                   margin: headerStyle.margin || '0',
                   padding: headerStyle.padding || '0',
                   lineHeight: headerStyle.lineHeight || 1.2,
                }}
                dangerouslySetInnerHTML={{ __html: header }} 
            />

            {/* Render Subheader only if enabled and non-empty */}
            {enableSubheader && subheader && (
                <Typography
                    component="h2"
                    sx={{
                        fontSize: subheaderStyle.subFontSize || '16px',
                        color: subheaderStyle.subheaderColor || '#666666',
                        fontWeight: subheaderStyle.subheaderFontWeight || 'normal',
                        textAlign: subheaderAlignment,
                         margin: subheaderStyle.margin || '0',
                         padding: subheaderStyle.padding || '0',
                         lineHeight: subheaderStyle.lineHeight || 1.35,
                    }}
                    dangerouslySetInnerHTML={{ __html: subheader }} 
                />
            )}
        </Box>
    );
};

HeaderFieldComponent.propTypes = {
    fieldId: PropTypes.string.isRequired,
};

export default HeaderFieldComponent;
